module.exports = __webpack_public_path__ + "img/ZA.8dc48856.svg";